import { render, staticRenderFns } from "./voip.vue?vue&type=template&id=6f6b0f6b&scoped=true"
import script from "./voip.vue?vue&type=script&lang=js"
export * from "./voip.vue?vue&type=script&lang=js"
import style0 from "./voip.vue?vue&type=style&index=0&id=6f6b0f6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b0f6b",
  null
  
)

export default component.exports